import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mt-auto border-t border-slate-200/50 dark:border-neutral-800/50 bg-white/60 dark:bg-neutral-900/40 backdrop-blur-sm pb-[max(1.5rem,env(safe-area-inset-bottom))]">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center justify-center gap-4 px-4 py-8">
        <Link
          to="/home"
          className="shrink-0 self-center rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500/60 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-neutral-900"
          aria-label="Ir para início"
        >
          <img
            src="/logo.png"
            alt="Green stats"
            className="h-14 w-auto max-w-[min(100%,260px)] shrink-0 object-contain md:h-16"
          />
        </Link>
        <p className="max-w-md text-center text-sm leading-relaxed text-slate-600 dark:text-neutral-400">
          Análise avançada de apostas em futebol. Compare times, confira estatísticas e tome decisões informadas.
        </p>
        <p className="text-center text-xs text-slate-500 dark:text-neutral-500">
          © {new Date().getFullYear()} Green stats. Análise de apostas em futebol.
        </p>
      </div>
    </footer>
  );
}
